"use strict";
/**
 * @copyright
 * Copyright (c) 2024 Accretive Technology Group, Inc. All rights
 * reserved. For use only by Accretive Technology, its employees
 * and contractors. DO NOT DISTRIBUTE.
 */
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FedmodBadge = void 0;
var FedmodBadge_1 = require("./FedmodBadge");
Object.defineProperty(exports, "FedmodBadge", { enumerable: true, get: function () { return __importDefault(FedmodBadge_1).default; } });
